module.exports = __webpack_public_path__ + "static/media/person-3.518e5f9a.jpg";